import moment from 'moment';
import { NOTIFICATION_TYPES } from './constants';

export const formatDate = (date: string) => {
  return date ? moment(date).format('DD/MM/YYYY') : '';
};
export const isTimeMoreThan3 = (createAt: string) => {
  const diff = moment.duration(moment().diff(moment(createAt)));
  const fromNow = diff.asHours();
  return fromNow > 3;
};
export const fromNow = (createdAt: string) => {
  const createAt = moment(createdAt);
  const currentDate = moment();
  const timeBetween = moment.duration(currentDate.diff(createAt));
  const hours = timeBetween.hours();
  const minutes = timeBetween.minutes();
  const days = timeBetween.days();
  return {
    hours,
    minutes,
    days,
  };
};
export const getNotificationIconType = (type: number | undefined) => {
  if (!type) {
    return '';
  }
  const currentNotificationType = NOTIFICATION_TYPES?.find(
    item => item.value === type,
  );

  return currentNotificationType?.icon || '';
};

// call this function, passing-in your date
export function dateToFromNowDaily(myDate: string) {
  // get from-now for this date
  const fromNowDay = moment(myDate).fromNow();
  // ensure the date is displayed with today and yesterday
  return moment(myDate).calendar(null, {
    // when the date is closer, specify custom values
    lastWeek: '[Last] dddd',
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    // when the date is further away, use from-now functionality
    sameElse() {
      return `[${fromNowDay}]`;
    },
  });
}

export const dayOfWeekToString = (day: number) => {
  return [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ][day];
};
